<section class="p-r-30 flex-row-space-between-start">
    <app-page-header-title title="Customer Questionnaire"></app-page-header-title>
</section>
<section class="edit-questions-section d-flex justify-space-between">
    <div class="d-flex align-center">
        <button
            (click)="enableCreateMode()"
            [disabled]="commonQuestionnaireService.isPublishInProgress"
            [routerLink]="'/cq/questionnaire'"
            color="primary"
            mat-flat-button
        >
            Edit questions
        </button>

        @if (commonQuestionnaireService.isPublishInProgress) {
        <span class="m-l-10 ds-icon-validation_error warning-icon fs-28"> </span>
        } @if (commonQuestionnaireService.isPublishInProgress) {
        <span class="m-l-5">A publish is currently in progress...wait a few moments to edit again.</span>
        }
    </div>

    <button
        (click)="refreshTable()"
        mat-icon-button
    >
        <mat-icon>refresh</mat-icon>
    </button>
</section>
<div class="resources-table d-flex flex-grow flex-direction-column">
    <!-- spinner -->
    @if (entityDataSource.IsLoading$ | async) {
    <div class="table-spinner">
        <mat-spinner
            [diameter]="60"
            [strokeWidth]="4"
        ></mat-spinner>
    </div>
    }

    <mat-table
        [dataSource]="entityDataSource"
        [ngClass]="{ 'empty-state-table': entityDataSource.Data.length === 0 }"
        class="full-width flex-grow overflow-auto height-1"
        matSort
        matSortActive="updatedAt"
        matSortDirection="desc"
    >
        Company Column
        <app-column-text
            (FilterChange)="onCompanyFilterChanged($event)"
            [(Filter)]="CompanyFilter"
            [cellTemplate]="companyCellTemplate"
            [entityBrowser]="this"
            columnKeyName="company"
            i18n-title
            title="Company"
        ></app-column-text>

        <ng-template
            #companyCellTemplate
            let-questionnaire
        >
            <p
                #tooltip="matTooltip"
                (click)="goToCustomerReview(questionnaire)"
                (mouseover)="checkInputClientVisibility($event, tooltip)"
                [matTooltipDisabled]="disableTooltip"
                [matTooltip]="getCompanyName(questionnaire)"
                [ngClass]="{ 'look-disabled': isCompanyQuestionnaireDisabled(questionnaire) }"
                class="text-ellipsis company-title"
            >
                {{ getCompanyName(questionnaire) }}
            </p>
        </ng-template>

        <!-- Status Column -->
        <app-column-select
            [(Filter)]="StatusFilter"
            [cellTemplate]="statusCellTemplate"
            [entityBrowser]="this"
            [getOptionText]="QuestionnaireStatus.getName"
            [options]="QuestionnaireStatus.getAllTypes()"
            asyncOptionValueProperty="value"
            columnKeyName="status"
            i18n-title
            title="Status"
        ></app-column-select>

        <ng-template
            #statusCellTemplate
            let-questionnaire
        >
            <mat-chip-listbox>
                <mat-chip disableRipple>
                    <span>{{ QuestionnaireStatus.getName(questionnaire.status) }}</span>
                </mat-chip>
            </mat-chip-listbox>
        </ng-template>

        <!--        Required answers column-->
        <app-column-select
            [(Filter)]="RequiredAnswersFilter"
            [cellTemplate]="requiredAnswersCellTemplate"
            [entityBrowser]="this"
            [getOptionText]="QuestionnaireRequiredAnswers.getName"
            [options]="QuestionnaireRequiredAnswers.getAllTypes()"
            columnKeyName="required_answers"
            i18n-title
            title="Required answers"
        ></app-column-select>

        <ng-template
            #requiredAnswersCellTemplate
            let-questionnaire
        >
            <mat-chip-listbox>
                <mat-chip disableRipple>
                    <span>{{ QuestionnaireRequiredAnswers.getName(questionnaire.required_answers) }}</span>
                </mat-chip>
            </mat-chip-listbox>
        </ng-template>

        <!--          Last updated column -->
        <app-column-date
            [(EndFilter)]="LastUpdateEndFilter"
            [(StartFilter)]="LastUpdateStartFilter"
            [entityBrowser]="this"
            columnKeyName="updatedAt"
            entityProperty="updatedAt"
            i18n-title
            title="Last update"
        >
        </app-column-date>

        <!--        Questions answered column-->
        <app-column-text
            [(Filter)]="QuestionsAnsweredFilter"
            [cellTemplate]="questionsAnsweredCellTemplate"
            [disabled]="true"
            [entityBrowser]="this"
            [placeholder]="''"
            [sortable]="false"
            columnKeyName="answered_questions"
            i18n-title
            title="Questions answered"
        >
        </app-column-text>

        <ng-template
            #questionsAnsweredCellTemplate
            let-questionnaire
        >
            <p>{{ questionnaire.answered_questions + '/' + questionnaire.total_questions }}</p>
        </ng-template>

        <app-column-progress
            [(Filter)]="ProgressFilter"
            [cellTemplate]="progressCellTemplate"
            [disabled]="true"
            [entityBrowser]="this"
            [placeholder]="''"
            [sortable]="false"
            columnKeyName="progress"
            i18n-title
            title="Progress to full version"
        >
        </app-column-progress>

        <ng-template
            #progressCellTemplate
            let-questionnaire
        >
            <app-mdr-progress-bar
                [maxValue]="questionnaire.total_questions"
                [value]="questionnaire.answered_questions"
            ></app-mdr-progress-bar>
        </ng-template>

        <mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="sticky-header"
        ></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ 'row-highlight': isHighlightedRow(row) }"
        ></mat-row>
    </mat-table>

    @if (entityDataSource.HasNoData$ | async) {
    <app-empty-state
        i18n-title
        title="No companies"
        type="noData"
    >
        <span i18n>You don't have any companies who accessed Customer Questionnaire yet.</span>
    </app-empty-state>
    } @if (entityDataSource.HasNoFilteredResults$ | async) {
    <app-empty-state
        i18n-title
        title="No results were found"
        type="noResults"
    >
        <span i18n>Try adjusting your search or filter options to find what you’re looking for.</span>
        <button
            mat-button
            color="primary"
            class="small-button quiet m-t-13"
            (click)="clearFilters()"
        >
            Clear filters
        </button>
    </app-empty-state>
    }

    <div class="sticky-paginator full-width position-sticky">
        <app-table-footer
            (page)="selection.clear()"
            (refreshTable)="refreshTable()"
            [pageSizeOptions]="[10, 25, 50]"
            [selectedItemsCount]="selection.getSelectedCount()"
            showFirstLastButtons
        >
        </app-table-footer>
    </div>
</div>
